import React from 'react';
import { motion } from 'framer-motion';
export function WhyItFailsSection() {
  return <section className="py-14 md:py-24 px-5 md:px-6 bg-[#0d1221]" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-10 md:mb-16" data-id="element-198">
          <h2 className="text-2xl md:text-4xl font-playfair text-[#f5f0e8] mb-2 md:mb-4" data-id="element-199">
            Why this keeps happening
            <span className="block text-base md:text-2xl text-[#8b8178] mt-1 md:mt-2 font-sans font-light italic" data-id="element-200">
              (and why the usual advice misses it)
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-201">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="space-y-4 md:space-y-6 opacity-60" data-id="element-202">
            <h3 className="text-lg md:text-xl font-semibold text-[#8b8178] uppercase tracking-widest mb-2 md:mb-4" data-id="element-203">
              The Front Door
            </h3>
            <p className="text-base md:text-lg" data-id="element-204">
              Most advice attacks sleep from the front door:
            </p>
            <ul className="space-y-2 md:space-y-3 border-l border-[#8b8178]/30 pl-4 md:pl-6" data-id="element-205">
              <li className="text-[#8b8178]" data-id="element-206">perfect bedtime routine</li>
              <li className="text-[#8b8178]" data-id="element-207">no screens</li>
              <li className="text-[#8b8178]" data-id="element-208">supplements</li>
              <li className="text-[#8b8178]" data-id="element-209">"just relax"</li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="space-y-4 md:space-y-6 relative" data-id="element-210">
            {/* Subtle glow effect behind */}
            <div className="absolute -inset-4 bg-[#c9a96e]/5 blur-2xl rounded-full pointer-events-none" data-id="element-211" />

            <h3 className="text-lg md:text-xl font-semibold text-[#c9a96e] uppercase tracking-widest mb-2 md:mb-4 relative z-10" data-id="element-212">
              The Side Door
            </h3>
            <p className="text-base md:text-lg relative z-10" data-id="element-213">
              But your problem shows up through the side door:
            </p>

            <div className="text-xl md:text-3xl font-playfair text-[#f5f0e8] leading-tight relative z-10" data-id="element-214">
              the first <span className="text-[#c9a96e]" data-id="element-215">120 seconds</span>{' '}
              after you wake up.
            </div>

            <p className="text-sm md:text-base text-[#e8e0d4] relative z-10" data-id="element-216">
              That's the window when the loop either:
              <br data-id="element-217" />
              <span className="opacity-70" data-id="element-218">— fizzles out… or</span>
              <br data-id="element-219" />
              <span className="text-[#c9a96e]" data-id="element-220">
                — locks in and steals the rest of the night.
              </span>
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="mt-12 md:mt-20 max-w-2xl mx-auto" data-id="element-221">
          <p className="text-base md:text-lg text-center mb-6 md:mb-8 text-[#e8e0d4]" data-id="element-222">
            If you don't have a plan for that moment, your brain will use the
            only plan it knows:
            <br data-id="element-223" />
            <strong className="text-[#f5f0e8] text-lg md:text-xl block mt-2" data-id="element-224">
              panic + problem-solving.
            </strong>
          </p>

          <div className="bg-[#111827] border-l-4 border-[#c9a96e] p-5 md:p-8 rounded-r-lg shadow-lg relative overflow-hidden" data-id="element-225">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-226">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" className="text-[#c9a96e]" data-id="element-227">
                <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" data-id="element-228" />
              </svg>
            </div>
            <p className="text-xs md:text-xs text-[#8b8178] mb-2 uppercase tracking-wide" data-id="element-229">
              And that teaches your nervous system one brutal lesson:
            </p>
            <p className="text-xl md:text-2xl font-playfair italic text-[#f5f0e8]" data-id="element-230">
              "Waking up at night means we need to work."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}